import React, { useContext } from 'react';
import styled from 'styled-components';
import StepPanel from '../StepPanel';
import SelectVirtualTour from './SelectVirtualTour';
import VirtualCoopSelectorStep from './VirtualCoopSelectorStep';
import VirtualTabContext from './VirtualTabContext';
import VirtualInvitees from './VirtualInvitees';
import PreBookingInfoAlert from '../components/PreBookingInfoAlert';

const VirtualTab: React.FC = () => {
  const { coop, bookFor } = useContext(VirtualTabContext);
  const step1Title = bookFor === 'self' ? 'Your Profile' : 'Select Agent';

  return (
    <StyledContainer>
      <PreBookingInfoAlert />
      <StyledStepsContainer $coopSelected={Boolean(coop)}>
        <StepPanel title={step1Title}>
          <VirtualCoopSelectorStep />
        </StepPanel>
        {coop && (
          <>
            <StepPanel title="Select Tour Name">
              <SelectVirtualTour />
            </StepPanel>
            <StepPanel title="Invite Guests">
              <VirtualInvitees />
            </StepPanel>
          </>
        )}
      </StyledStepsContainer>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  padding-top: 16px;
`;

const StyledStepsContainer = styled.div<{ $coopSelected: boolean }>`
  display: grid;
  grid-template-columns: ${({ $coopSelected }) =>
    $coopSelected
      ? 'repeat(auto-fit, minmax(300px, 1fr))'
      : 'clamp(300px, 100%, 450px)'};
  gap: 32px;
`;

export default VirtualTab;
